import { ColorPicker as ColorPickerInit, Flex } from 'antd';
import s from './colorPickre.module.scss'

export const ColorPicker = ({ size = "large", defaultFormat = 'hex', ...props }) => {
    const renderText = (value) => {
        let hexValue = value.toHexString().toUpperCase()
        return (
            <div className={s.text_wrapper}>
                <Flex
                    justify='space-between'
                    style={{ width: '100%' }}
                >
                    <span className={s.hex_block}>{value.metaColor.a===1 ? hexValue : hexValue.slice(0, -2)}</span>
                    <span className={s.percent_block}>{Math.round(value.metaColor.a * 100)}%</span>
                </Flex>
            </div>
        )
    }
    return (
        <>
            <ColorPickerInit
                size={size}
                showText={renderText}
                defaultFormat={defaultFormat}
                {...props}
            />
        </>
    )
}